const encodePathSegment = (value) => {
    return encodeURIComponent(String(value));
};

const companyBase = (companyId) => {
    return `/companies/${encodePathSegment(companyId)}`;
};

const customerBase = (companyId) => {
    return `${companyBase(companyId)}/customer`;
};

const supplierBase = (companyId) => {
    return `${companyBase(companyId)}/supplier`;
};

const customerRulesBase = (companyId) => {
    return `${customerBase(companyId)}/rules`;
};

const supplierRulesBase = (companyId) => {
    return `${supplierBase(companyId)}/rules`;
};

const endpoints = {
    auth: {
        login: '/auth/login',
    },

    companies: {
        list: '/companies',
        create: '/companies',

        show: (companyId) =>
            companyBase(companyId),

        update: (companyId) =>
            companyBase(companyId),

        remove: (companyId) =>
            companyBase(companyId),
    },

    customer: {
        initialize: (companyId) =>
            customerBase(companyId),

        upload: (companyId) =>
            `${customerBase(companyId)}/imports`,

        generate: (companyId) =>
            `${customerBase(companyId)}/exports`,

        generateExcel: (companyId) =>
            `${customerBase(companyId)}/excel-exports`,

        download: (companyId) =>
            `${customerBase(companyId)}/downloads`,

        rules: {
            list: (companyId) =>
                customerRulesBase(companyId),

            create: (companyId) =>
                customerRulesBase(companyId),

            update: (companyId, ruleId) =>
                `${customerRulesBase(companyId)}/${encodePathSegment(ruleId)}`,

            remove: (companyId, ruleId) =>
                `${customerRulesBase(companyId)}/${encodePathSegment(ruleId)}`,

            removeAll: (companyId) =>
                customerRulesBase(companyId),
        },
    },

    supplier: {
        initialize: (companyId) =>
            supplierBase(companyId),

        upload: (companyId) =>
            `${supplierBase(companyId)}/imports`,

        generate: (companyId) =>
            `${supplierBase(companyId)}/exports`,

        generateExcel: (companyId) =>
            `${supplierBase(companyId)}/excel-exports`,

        download: (companyId) =>
            `${supplierBase(companyId)}/downloads`,

        rules: {
            list: (companyId) =>
                supplierRulesBase(companyId),

            create: (companyId) =>
                supplierRulesBase(companyId),

            update: (companyId, ruleId) =>
                `${supplierRulesBase(companyId)}/${encodePathSegment(ruleId)}`,

            remove: (companyId, ruleId) =>
                `${supplierRulesBase(companyId)}/${encodePathSegment(ruleId)}`,

            removeAll: (companyId) =>
                supplierRulesBase(companyId),
        },
    },
};

export default endpoints;


// WEBPACK FOOTER //
// ./src/api/endpoints.js